export default __webpack_public_path__ + "static/media/webzampiano.b7d9ed51.png";